angular.module("vgresiduos").directive("destinationTracking", function () {
	return {
		scope: true,
		controller: "DestinationTrackingCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/stages/destinationTracking/destinationTracking_template.html"
	};
});
